<div *ngIf="entity"
  class="previewCard middle unselectable"
  fxLayout="column"
  (click)="goToDetail()">

  <!-- image -->
  <div class="list-item-image"
    [style.background-image]="entity.mainImage ? entity.mainImage.safe : ''">

    <!-- video -->
    <iframe *ngIf="entity.videourlSafe"
      [src]="entity.videourlSafe"
      frameborder="0"
      allow="fullscreen"
      allowfullscreen
      style="height: 100%; width: 100%;"></iframe>

    <!-- price triangle - positioned absolute -->
    <div class="triangle">
      <div *ngIf="entity && entity.entityTypeIdentifier == 'advert'; else categoryName;"
        class="price-content"
        style="color: white;">
        {{entity.price | moneyInsertThousandSigns}}€ {{entity.price_mode | enumtranslate}}
      </div>
      <ng-template #categoryName>
        {{ entity.category.name }}
      </ng-template>
    </div>

  </div>

  <!-- content -->
  <div fxLayout="column"
    fxLayoutGap="10px"
    class="content">

    <author [profile]="entity.profile_type===ProfileTypeIdentifier.business ? UserService.user.company_profile : UserService.user"
      [created_at]="entity.created_at"
      [lightgraymode]="true">
    </author>

    <div fxFlex="grow"
      fxLayout="column"
      class="overflow-hidden"
      style="position: relative;">
      <div class="title">{{ entity.title }}</div>
      <div class="entityContentText"
        [innerHTML]="entity.content"></div>
      <div class="fadeout"></div>
    </div>

    <!-- edit buttons -->
    <div *ngIf="mode=='edit'"
      fxFlex="noshrink"
      fxLayout="column"
      fxLayoutAlign="end center"
      fxLayoutGap="10px">

      <!-- hidden if video -->
      <div fxLayout="row"
        fxLayoutAlign="center center"
        fxLayoutGap="5px"
        *ngIf="entity.category.id != CategoriesService.videocat.id">
        <div>Gelesen</div>
        <views-display [views]="entity.count_views"></views-display>
      </div>

      <div fxLayout="row"
        fxLayoutAlign="center center"
        fxLayoutGap="5px">
        <div>Impressionen</div>
        <views-display [views]="entity.count_impressions"></views-display>
      </div>

      <button (click)="$event.stopPropagation();edit()"
        fxLayout="row"
        fxLayoutGap="10px"
        fxLayoutAlign="center center"
        class="dark-grey-button growBtn">
        <i class="fas fa-edit"></i>
        <div>Bearbeiten</div>
      </button>

      <button (click)="$event.stopPropagation();delete(entity);"
        fxLayout="row"
        fxLayoutGap="10px"
        fxLayoutAlign="center center"
        class="dark-grey-button growBtn">
        <i class="fas fa-trash-alt"></i>
        <span>Löschen</span>
      </button>
    </div>

  </div>
</div>
